import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import ThresholdPage from "./components/ThresholdPage";
import WelcomePage from "./components/WelcomePage";
import QuizPage from "./components/QuizPage";
import LifeMapPage from "./components/LifeMapPage";
import PathPage from "./components/PathPage";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import ProfilePage from "./components/ProfilePage";
import AdminPage from "./components/AdminPage";
import DeepDivePage from "./components/DeepDivePage";
import VillageTVPage from "./components/VillageTVPage";
import AboutPage from "./components/AboutPage";
import MerchPage from "./components/MerchPage";
import MirrorPage from "./components/MirrorPage";
import JournalPage from "./components/JournalPage";
import CheckoutSuccessPage from "./components/CheckoutSuccessPage";
import MusicPage from "./components/MusicPage";
import BookPage from "./components/BookPage";
import VillageDailyPage from "./components/VillageDailyPage";
import BookCabriniPage from "./components/BookCabriniPage";
import AlchemyJourney from "./components/AlchemyJourney";
// import GangstaAIPage from "./components/GangstaAIPage"; // TEMPORARILY TAKEN DOWN — being replaced by new AI business landing page
import GangstaAISeniorsHub from "./components/GangstaAISeniorsHub";
import SummitSuccessPage from "./components/SummitSuccessPage";
import MakeMusicAIPage from "./components/MakeMusicAIPage";
import GiftPage from "./components/GiftPage";
import GiftReadPage from "./components/GiftReadPage";
import BookPromoPage from "./components/BookPromoPage";
import PromoPage from "./components/PromoPage";
import PullACardPage from "./components/PullACardPage";
import GiftDeckRedeemPage from "./components/GiftDeckRedeemPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Standalone book promo page — no nav, no banner, no audio */}
            <Route path="/the-book" element={<BookPromoPage />} />

            {/* Standalone cinematic experience — fullscreen, no nav/banner */}
            <Route path="/experience" element={<PromoPage />} />

            <Route element={<Layout />}>
              <Route path="/" element={<ThresholdPage />} />
              <Route path="/welcome" element={<WelcomePage />} />
              <Route path="/quiz" element={<QuizPage />} />
              <Route path="/life-map" element={<LifeMapPage />} />
              <Route path="/path/:pathId" element={<PathPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/deepdive" element={<DeepDivePage />} />
              <Route path="/tv" element={<VillageTVPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/pull-a-card" element={<PullACardPage />} />
              <Route path="/redeem/:code" element={<GiftDeckRedeemPage />} />
              <Route path="/merch" element={<MerchPage />} />
              <Route path="/merch/success" element={<CheckoutSuccessPage />} />
              <Route path="/music" element={<MusicPage />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/daily" element={<VillageDailyPage />} />
              <Route path="/book-cabrini" element={<BookCabriniPage />} />
              <Route path="/journey" element={<AlchemyJourney />} />
              {/* Gangsta AI page temporarily taken down — redirect to home until new landing page is ready */}
              <Route path="/gangsta-ai" element={<Navigate to="/" replace />} />
              <Route path="/summit" element={<GangstaAISeniorsHub />} />
              <Route path="/summit/success" element={<SummitSuccessPage />} />
              <Route path="/make-music-ai" element={<MakeMusicAIPage />} />
              <Route path="/gift" element={<GiftPage />} />
              <Route path="/gift/read" element={<GiftReadPage />} />
              <Route path="/mirror" element={<MirrorPage />} />
              <Route path="/journal" element={<JournalPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
